"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFeatureEventPayloadWithFunc = exports.updateFeatureDescription = exports.updateFeatureName = exports.updateFeatureEventPayload = exports.getStepsFromScenarios = exports.deleteActor = exports.updateActorName = exports.addActor = exports.deleteStep = exports.updateStepEventName = exports.addStep = exports.DEFAULT_EVENT_NAME = exports.duplicateScenario = exports.deleteScenario = exports.updateScenarioDescription = exports.updateScenarioName = exports.addFeature = exports.addScenario = exports.getActorsWithSteps = exports.flattenDatabase = void 0;
var human_id_1 = require("human-id");
var immer_1 = require("immer");
var sanitizeUtilities_1 = require("./sanitizeUtilities");
var uuid = function () { return human_id_1.default(); };
/**
 * Flattens the database into a series of arrays, instead
 * of keyed objects.
 *
 * Also sanitizes various names by camelcasing them
 */
exports.flattenDatabase = function (database) {
    return {
        features: Object.values(database.features).map(function (feature) {
            return __assign(__assign({}, sanitizeUtilities_1.sanitizeFeature(feature)), { actors: Object.values(feature.actors).map(sanitizeUtilities_1.sanitizeActor), scenarios: Object.values(feature.scenarios).map(sanitizeUtilities_1.sanitizeScenario) });
        }),
    };
};
exports.getActorsWithSteps = function (actors, steps) {
    return actors.map(function (env) {
        return __assign(__assign({}, env), { from: actors
                .map(function (fromEnv) {
                return {
                    env: fromEnv.name,
                    in: steps.filter(function (step) {
                        return step.to === env.id && step.from === fromEnv.id;
                    }),
                    out: steps.filter(function (step) {
                        return step.from === env.id && step.to === fromEnv.id;
                    }),
                };
            })
                .filter(function (fromEnv) {
                return fromEnv.in.length > 0 || fromEnv.out.length > 0;
            }), to: actors
                .map(function (toEnv) {
                return {
                    env: toEnv.name,
                    in: steps.filter(function (step) {
                        return step.from === env.id && step.to === toEnv.id;
                    }),
                    out: steps.filter(function (step) {
                        return step.to === env.id && step.from === toEnv.id;
                    }),
                };
            })
                .filter(function (fromEnv) {
                return fromEnv.in.length > 0 || fromEnv.out.length > 0;
            }) });
    });
};
/** Scenarios */
exports.addScenario = function (database, featureId) {
    return immer_1.default(database, function (draft) {
        var feature = draft.features[featureId];
        var id = uuid();
        feature.scenarios[id] = {
            id: id,
            description: 'Description',
            name: 'New Scenario',
            order: Object.keys(feature.scenarios).length,
            steps: [],
        };
    });
};
exports.addFeature = function (database) {
    return immer_1.default(database, function (draft) {
        var id = uuid();
        draft.features[id] = {
            id: id,
            actors: {},
            description: 'Description',
            eventPayloads: '',
            name: 'New Feature',
            scenarios: {},
        };
    });
};
exports.updateScenarioName = function (database, featureId, scenarioId, name) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].scenarios[scenarioId].name = name;
    });
};
exports.updateScenarioDescription = function (database, featureId, scenarioId, description) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].scenarios[scenarioId].description = description;
    });
};
exports.deleteScenario = function (database, featureId, scenarioId) {
    return immer_1.default(database, function (draft) {
        delete draft.features[featureId].scenarios[scenarioId];
    });
};
exports.duplicateScenario = function (database, featureId, scenarioId) {
    return immer_1.default(database, function (draft) {
        var newId = uuid();
        draft.features[featureId].scenarios[newId] = __assign(__assign({}, draft.features[featureId].scenarios[scenarioId]), { id: newId });
    });
};
exports.DEFAULT_EVENT_NAME = 'EVENT';
/** Steps */
exports.addStep = function (_a) {
    var database = _a.database, fromEnvId = _a.fromEnvId, index = _a.index, scenarioId = _a.scenarioId, featureId = _a.featureId, toEnvId = _a.toEnvId;
    return immer_1.default(database, function (draft) {
        draft.features[featureId].scenarios[scenarioId].steps.splice(index, 0, {
            event: exports.DEFAULT_EVENT_NAME,
            id: uuid(),
            from: fromEnvId,
            to: toEnvId,
        });
    });
};
exports.updateStepEventName = function (database, featureId, scenarioId, stepIndex, name) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].scenarios[scenarioId].steps[stepIndex].event = name;
    });
};
exports.deleteStep = function (database, featureId, scenarioId, stepIndex) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].scenarios[scenarioId].steps.splice(stepIndex, 1);
    });
};
/** Actor */
exports.addActor = function (database, featureId) {
    return immer_1.default(database, function (draft) {
        var newId = uuid();
        draft.features[featureId].actors[newId] = {
            id: newId,
            name: 'New Actor',
        };
    });
};
exports.updateActorName = function (database, featureId, scenarioId, envId, name) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].scenarios[scenarioId];
        draft.features[featureId].actors[envId].name = name;
    });
};
exports.deleteActor = function (database, featureId, envId) {
    Object.values(database.features[featureId].scenarios).forEach(function (feature) {
        feature.steps.forEach(function (step) {
            if (step.from === envId || step.to === envId) {
                throw new Error('This actor cannot be deleted because steps depend on it.');
            }
        });
    });
    return immer_1.default(database, function (draft) {
        delete draft.features[featureId].actors[envId];
    });
};
exports.getStepsFromScenarios = function (scenarios) {
    return scenarios.reduce(function (accum, scenario) {
        return accum.concat(scenario.steps.reduce(function (stepAccum, step) {
            return stepAccum.concat(step);
        }, []));
    }, []);
};
exports.updateFeatureEventPayload = function (database, featureId, eventPayloads) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].eventPayloads = eventPayloads;
    });
};
exports.updateFeatureName = function (database, featureId, name) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].name = name;
    });
};
exports.updateFeatureDescription = function (database, featureId, description) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].description = description;
    });
};
exports.updateFeatureEventPayloadWithFunc = function (database, featureId, func) {
    return immer_1.default(database, function (draft) {
        draft.features[featureId].eventPayloads = func(draft.features[featureId].eventPayloads);
    });
};
